module.exports = __webpack_public_path__ + "static/media/backpack.5ec12ce8.svg";